import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '@fortawesome/fontawesome-free/css/all.min.css';

import Button from '../../general/Button/Button';
import Alert from '../../intern/Alert/Alert';

import './TableInform.css';

const TableUserPendingForm = ({ dados = [], onAprovar, onReprovar }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [alert, setAlert] = useState(null);

  // Aprovar individual
  const handleAprovarItem = async (uid) => {
    try {
      await onAprovar(uid);
      setAlert('adicionar');
    } catch {
      setAlert('erro');
    }
  };

  // Reprovar individual (abre popup via onReprovar)
  const handleReprovarItem = (uid) => {
    onReprovar(uid);
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else {
      setSelectedItems(dados.map(item => item.uid));
    }
    setSelectAll(!selectAll);
  };

  const handleSelectItem = (uid) => {
    setSelectedItems(prev => {
      if (prev.includes(uid)) {
        return prev.filter(id => id !== uid);
      }
      return [...prev, uid];
    });
  };

  const handleBulkAction = async (actionType) => {
    if (selectedItems.length < 2) {
      setAlert('info');
      return;
    }

    try {
      if (actionType === 'aprovar') {
        await onAprovar(selectedItems);
        setAlert('adicionar');
      } else if (actionType === 'reprovar') {
        onReprovar(selectedItems); // abrir popup para confirmação
      }
      setSelectedItems([]);
      setSelectAll(false);
    } catch {
      setAlert('erro');
    }
  };

  return (
    <div>
      {alert && <Alert type={alert} onClose={() => setAlert(null)} />}

      <table className="tabela">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
                aria-label="Selecionar todos"
              />
            </th>
            <th>Nome Completo</th>
            <th>E-mail</th>
            <th>Ação</th>
          </tr>
        </thead>
        <tbody>
          {dados.map((item, idx) => (
            <tr key={item.uid || idx}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedItems.includes(item.uid)}
                  onChange={() => handleSelectItem(item.uid)}
                  aria-label={`Selecionar usuário ${item.userName ?? "sem nome"}`}
                />
              </td>
              <td>{item.userName ?? "—"}</td>
              <td>{item.userEmail ?? "—"}</td>
              <td>
                <button
                  className="tabela-aprovar"
                  onClick={() => handleAprovarItem(item.uid)}
                  aria-label={`Aprovar usuário ${item.userName ?? "sem nome"}`}
                >
                  <i className="fa fa-check"></i>
                </button>
                <button
                  className="tabela-reprovar"
                  onClick={() => handleReprovarItem(item.uid)}
                  aria-label={`Reprovar usuário ${item.userName ?? "sem nome"}`}
                >
                  <i className="fa fa-times"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedItems.length >= 2 && (
        <div className="bulk-actions">
          <Button
            variant="save"
            className="btn-save"
            onClick={() => handleBulkAction('aprovar')}
          >
            Aprovar
          </Button>
          <Button
            variant="delete"
            className="btn-delete"
            onClick={() => handleBulkAction('reprovar')}
          >
            Reprovar
          </Button>
        </div>
      )}
    </div>
  );
};

TableUserPendingForm.propTypes = {
  dados: PropTypes.arrayOf(
    PropTypes.shape({
      userName: PropTypes.string,
      userEmail: PropTypes.string,
      uid: PropTypes.string,
    })
  ),
  onAprovar: PropTypes.func.isRequired,
  onReprovar: PropTypes.func.isRequired,
};

export default TableUserPendingForm;
